import React from 'react';
import SchedulePage from '../schedule/SchedulePage';

// Duty and on-call rosters (Firestore collection "gardeAstreinte"): a period, a unit and the
// roster documents. Actions follow the level of each account (rights grid, section "gardes").
const GARDES = {
  collection: 'gardeAstreinte',
  section: 'gardes',
  eyebrow: 'Équipe',
  title: 'Gardes et astreintes',
  tint: { current: 'bg-amber-500 text-white', idle: 'bg-amber-50 text-amber-700' },
  types: null,
  words: {
    one: 'tableau',
    many: 'tableaux',
    add: 'Ajouter un tableau',
    editTitle: 'Modifier le tableau',
    deleteTitle: 'Supprimer le tableau',
    fallbackName: 'Tableau de garde',
    titleHint: 'Facultatif, par exemple « Gardes d’octobre ».',
    searchPlaceholder: 'Intitulé, date, document…',
    searchLabel: 'Rechercher un tableau',
    loading: 'Chargement des tableaux…',
    unavailable: 'Tableaux indisponibles',
    emptyUpcoming: 'Aucun tableau en cours ou à venir',
    emptyPast: 'Aucun tableau passé',
    emptyUndated: 'Aucun tableau sans date',
    upcomingHint: 'Les tableaux de garde et d’astreinte apparaîtront ici.',
    noMatch: 'Aucun tableau ne correspond à cette recherche.',
    missingDate: 'Indiquez la période du tableau.',
    added: 'Tableau ajouté.',
    updated: 'Tableau mis à jour.',
    deleted: 'Tableau supprimé.',
    saveFailed: 'Le tableau n’a pas pu être enregistré. Vérifiez la connexion, puis réessayez.',
    deleteFailed: 'Le tableau n’a pas pu être supprimé.',
  },
};

const GardesPage = () => <SchedulePage config={GARDES} />;

export default GardesPage;
